import Plugin from 'src/plugin-system/plugin.class';
import ViewportDetection from 'src/helper/viewport-detection.helper';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class ZeitstrahlPlugin extends Plugin {

    static options = {
      viewPorts: [
          'XXS',
          'XS',
          'SM',
          'MD'
      ]
    };

    init() {
      this._registerEvents();
      this._initScroller();
    }

    _registerEvents() {
      document.addEventListener('Viewport/hasChanged', () => {
        this._initScroller();
      });
    }

    _initScroller() {

      if (this.options.viewPorts.includes(ViewportDetection.getCurrentViewport())) {
        return;
      }

      gsap.registerPlugin(ScrollTrigger);
      let inner = document.querySelector(".zeitstrahl-widget__inner");

      gsap.to(inner, {
        x: () => -(inner.scrollWidth - document.documentElement.clientWidth) + "px",
        ease: "none",
        scrollTrigger: {
          trigger: ".zeitstrahl-widget",
          start: "bottom bottom",
          pin: true,
          scrub: 1,
        }
      });
    }
}